import { useQuery } from '@tanstack/react-query';
import { getTestsList, ResponseGetTestsList } from './api/getTestsList';
import { useParams } from 'react-router-dom';
import { SlideItem } from './SlideItem';
import { useTranslation } from 'react-i18next';
import {
  getTestsData,
  ResponseGetTestsData,
  TestsData,
} from './api/getTestsData';
import { motion } from 'framer-motion';

type Dashboard = {
  currentTest: TestsData;
  data: ResponseGetTestsList;
};

function processTests(
  listTests: ResponseGetTestsData,
  value: ResponseGetTestsList
) {
  const tempList: Dashboard[] = [];

  for (const i of listTests) {
    const data: ResponseGetTestsList = value.filter(
      j => j.type?.toLowerCase() === i.id?.toLowerCase()
    );

    if (data.length > 0) {
      tempList.push({
        currentTest: i,
        data,
      });
    }
  }

  tempList.sort((a, b) => {
    const mostRecentA = a.data[a.data.length - 1];
    const mostRecentB = b.data[b.data.length - 1];

    return (
      new Date(mostRecentB.creationDate).getTime() -
      new Date(mostRecentA.creationDate).getTime()
    );
  });

  return tempList;
}

export const TestSlider = () => {
  const { i18n } = useTranslation();

  const { client } = useParams();

  const { data: testData } = useQuery<ResponseGetTestsData>({
    queryKey: ['tests-data', i18n.language],
    staleTime: 60 * 60 * 1000,
    queryFn: () => getTestsData({ lang: i18n.language }),
  });

  const { data } = useQuery<ResponseGetTestsList>({
    queryKey: ['tests', i18n.language, client],
    staleTime: 5 * 60 * 1000,
    queryFn: () => getTestsList({ user: client! }),
  });

  if (!testData || !data) {
    return null;
  }

  const dashboard = processTests(testData!, data!);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <h3>{i18n.t('psy.tests')}</h3>
      <div className="carousel rounded-box mt-4 flex gap-2">
        {dashboard.map(item => (
          <SlideItem
            key={item.currentTest.id}
            type={item.currentTest.id}
            title={item.currentTest.title}
            levels={item.currentTest.levels}
            data={item.data}
          />
        ))}
      </div>
    </motion.div>
  );
};
